import styles from './PeekDown.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { toggle, dismiss } from 'store/peekDown/peekDown';
import { ChevronIcon, CloseIcon } from 'seek-style-guide/react';
import TransitionGroup from 'react/lib/ReactCSSTransitionGroup';

const TRANSITIONS = Object.freeze({
  enter: styles.enter,
  enterActive: styles.enter_Active,
  leave: styles.leave,
  leaveActive: styles.leave_Active
});

const mapStateToProps = ({ peekDown }) => ({
  open: peekDown.open,
  show: peekDown.show
});

const mapDispatchToProps = dispatch => ({
  toggleHandler: () => dispatch(toggle()),
  dismissHandler: () => dispatch(dismiss())
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PeekDown extends Component {

  static propTypes = {
    message: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    open: PropTypes.bool.isRequired,
    show: PropTypes.bool.isRequired,
    toggleHandler: PropTypes.func.isRequired,
    dismissHandler: PropTypes.func.isRequired
  };

  renderClosed() {
    const { message, toggleHandler } = this.props;

    return (
      <p className={styles.prompt} onClick={toggleHandler}>
        { message }
        <span className={styles.learnMore}>Learn more</span>
        <ChevronIcon
          direction="down"
          svgClassName={styles.chevronSvg}
          className={styles.chevron}
        />
      </p>
    );
  }

  render() {
    const { open, children, show, dismissHandler } = this.props;
    const className = classnames({
      [styles.root]: true,
      [styles.root_isOpen]: open
    });

    return (
      <TransitionGroup
        transitionName={TRANSITIONS}
        transitionEnterTimeout={800}
        transitionLeaveTimeout={800}>
        { show ?
          <div className={className} aria-hidden="true">
            <div className={styles.inner}>
              { this.renderClosed() }
              <div className={styles.content}>
                { children }
              </div>
            </div>
            <CloseIcon
              className={styles.close}
              svgClassName={styles.closeSvg}
              title="Dismiss"
              onClick={dismissHandler}
            />
            <div className={styles.backdrop} />
          </div> : null }
      </TransitionGroup>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/PeekDown/PeekDown.js
 **/